// スリープ
export const sleep = async (msec: number) => {
  return new Promise((resolve) => setTimeout(resolve, msec))
}
